import BlofinLiveOrderPanel from './BlofinLiveOrderPanel';
import {
  confirmBitunixLiveOrder,
  createBitunixLiveIntent,
  fetchBitunixLiveAccountStatus,
  fetchBitunixLiveInstruments,
  fetchBitunixLiveOrder,
  reconcileBitunixLiveOrder,
} from '../../api/manualTrading';

const BITUNIX_API = {
  fetchStatus: fetchBitunixLiveAccountStatus,
  fetchInstruments: fetchBitunixLiveInstruments,
  createIntent: createBitunixLiveIntent,
  fetchOrder: fetchBitunixLiveOrder,
  confirm: confirmBitunixLiveOrder,
  reconcile: reconcileBitunixLiveOrder,
};

export default function BitunixLiveOrderPanel() {
  return (
    <BlofinLiveOrderPanel
      exchangeName="Bitunix"
      api={BITUNIX_API}
      reconcileLabel="Réconcilier les protections"
      refreshBeforeReconcile
      reconcileCreatesOrders
      reconcileRequiresAcknowledgement
    />
  );
}
